<template>
  <div>
    <div class="d-flex">
      <div class="p-1 image_div">
        <el-image
          :src="defaultImageUrl"
          :preview-src-list="[defaultImageUrl]"
          style="width:135px; height:135px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:135px; height:135px"
            />
          </div>
        </el-image>
      </div>
      <div style="flex:1">
        <div class="el-descriptions">
          <div class="el-descriptions__body descriptions__body_header">
            <div
              class="el-descriptions__table is-bordered el-descriptions--small"
            >
              <div class="el-descriptions-row">
                <div
                  class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label bg-white"
                  style="padding:6px"
                >
                  <div class="sku_main">
                    <div>
                      <span v-if="detail.goodsName">
                        {{ detail.goodsName }}
                      </span>
                    </div>
                    <div>
                      <span v-if="detail.goodsNameEn">
                        {{ detail.goodsNameEn }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-descriptions border size="small" class="bottom-desc" :column="2">
          <el-descriptions-item
            :label="$l('form_label_skuNo') || 'SKU款号'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ detail.amzSkuNo }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_ncNo') || 'NC编号'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ detail.ncNo }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_brandName') || '品牌'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ detail.brandName }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_collectionName') || '系列'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ detail.collectionName }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_pattern') || '花型'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ detail.goodsPattern }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_categoryFullName') || '品类'"
            :labelStyle="{ width: '120px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ displayCategoryName }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions border size="small" class="bottom-desc" :column="2">
          <el-descriptions-item
            :label="$l('form_label_goodsSize') || '尺寸'"
            :labelStyle="{ width: '103px', height: '32px' }"
            :contentStyle="{ width: '305px', height: '32px' }"
          >
            {{ detail.goodsSize }}
          </el-descriptions-item>

          <el-descriptions-item
            :label="$l('form_label_inCtnQty') || '入数'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '100px', height: '32px' }"
          >
            {{ detail.inCtnQty }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <SampleTable
      class="mt-4"
      ref="sampleTable"
      :disabled="disabled"
      :amzPurchaseDetailCode="amzPurchaseDetailCode"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      v-if="backDialogVisible"
      :visible.sync="backDialogVisible"
      width="30%"
      @close="() => (backDialogVisible = false)"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SampleTable from './table.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { SampleTable },
  mixins: [EditLoading],
  props: {
    amzPurchaseDetailCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { detail: {}, backDialogVisible: false }
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.detail
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
    displayCategoryName() {
      const { masterCategoryName, detailCategoryName } = this.detail
      return [masterCategoryName, detailCategoryName].filter(Boolean).join('/')
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzPurchaseDetailCode) return

      const res = await this.$api
        .ecomAmzFtyPurchaseDetailDetailApi({
          amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        })
        .catch(() => null)
      this.detail = res?.body || {}
    },
    async save() {
      const $sampleTable = this.$refs.sampleTable

      if (!(await $sampleTable.validate())) return (this.backDialogVisible = false)

      const params = {
        amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        sampleItems: $sampleTable.getTableData(),
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFtyPurchaseSampleSetApi({ ...params })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_set_no') || '填报失败')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('tips_set_ok') || '填报成功',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.image_div {
  border: 1px solid #ebeef5;
  border-right: none;
}

.sku_main {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  // height: 49px;
  // line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side_frame_div {
  height: 25px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
